<template>
  <gallery-thumbnail-overlay background-color="rgba(248, 114, 114, 0.8)">
    <div class="error-overlay-container">
      <div style="padding: 8px">
        <TextBody :font-size="0.9" color="white">
          {{ message }}
        </TextBody>
      </div>
      <div class="error-overlay-bottom">
        <v-icon
          style="color: white"
          v-if="action"
          @click="() => action.action()"
        >
          {{ action.icon }}
        </v-icon>
      </div>
    </div>
  </gallery-thumbnail-overlay>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import GalleryThumbnailOverlay from "features/gallery/thumbnail/GalleryThumbnailOverlay.vue"
import { GalleryThumbnailAction } from "features/gallery/thumbnail/GalleryThumbnail.vue"
import TextBody from "components/UI/TextBody.vue"

export default defineComponent({
  name: "GalleryThumbnailErrorOverlay",
  components: { TextBody, GalleryThumbnailOverlay },
  props: {
    message: {
      type: String,
      required: true,
    },
    action: {
      type: Object as PropType<GalleryThumbnailAction>,
    },
  },
})
</script>

<style scoped>
.error-overlay-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}

.error-overlay-bottom {
  width: 100%;
  height: 28px;
  padding: 8px;
  display: flex;
  justify-content: space-between;
}
</style>
